import { useRef } from "react";
import styled from "styled-components";

import SHADOWS from "components/atoms/shadows";
import COLORS from "components/atoms/colors";
import { TextSm } from "components/atoms/text";
import Modal from "components/organisms/Modal";
import ModalDelete from "components/organisms/ModalDelete";

import useDropdown from "hooks/useDropdown";

import { ReactComponent as IconMenu } from "assets/images/common/more-menu.svg";

interface Props {
  onOpenForm: () => void;
  onDelete: () => void;
  icon?: {
    size?: number;
    color?: string;
  };
}

// 수정, 삭제 드롭다운 메뉴
const DropdownMenu = ({ onOpenForm, icon, onDelete }: Props) => {
  const element = useRef(null);
  const [show, setShow] = useDropdown(element);

  const handleClickEdit = () => {
    onOpenForm();
    setShow(false);
  };

  return (
    <div ref={element} className="relative flex flex-col justify-center">
      <button onClick={() => setShow(!show)}>
        <BtnIcon
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 20 20"
          color={icon?.color}
          size={icon?.size}
        />
      </button>
      {show && (
        <OptionWrapper>
          <OptionItem onClick={handleClickEdit}>
            <TextSm>수정하기</TextSm>
          </OptionItem>
          <Modal
            activator={(onOpen) => (
              <OptionItem onClick={onOpen}>
                <TextSm className="text-error-active">삭제하기</TextSm>
              </OptionItem>
            )}
            modal={(onClose) => (
              <ModalDelete onClose={onClose} onDelete={onDelete} />
            )}
          />
        </OptionWrapper>
      )}
    </div>
  );
};

const OptionWrapper = styled.ul`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 96px;
  z-index: 2;
  background: #ffffff;
  box-shadow: ${SHADOWS.card};
  border-radius: 4px;
  overflow: hidden;
`;

const OptionItem = styled.li`
  padding: 12px;
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.white["60%"]};
  }
`;

const BtnIcon = styled(IconMenu)<{ color?: string; size?: number }>`
  width: ${({ size }) => size || 20}px;
  height: ${({ size }) => size || 20}px;
  path {
    fill: ${({ color }) => color || COLORS.black["40%"]};
  }
`;

export default DropdownMenu;
